import { useInfiniteQuery } from '@tanstack/react-query'
import * as commandsApi from '../api/commands.api'
import { QUERY_KEYS, STALE_TIME } from '../utils/constants'

const DEFAULT_PAGE_SIZE = 20

export function useDeviceCommands(deviceId: string, params?: { status?: string }) {
  const {
    data,
    isLoading,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
  } = useInfiniteQuery({
    queryKey: [...QUERY_KEYS.deviceCommands(deviceId), params],
    queryFn: ({ pageParam }) =>
      commandsApi.getByDevice(deviceId, {
        ...params,
        limit: DEFAULT_PAGE_SIZE,
        cursor: pageParam as string | undefined,
      }),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) =>
      lastPage.hasMore ? lastPage.nextCursor : undefined,
    staleTime: STALE_TIME.default,
    enabled: !!deviceId,
  })

  const items = data?.pages.flatMap((page) => page.items) ?? []

  return {
    items,
    isLoading,
    isFetchingNextPage,
    hasNextPage: hasNextPage ?? false,
    fetchNextPage,
  }
}
